module.exports = __webpack_public_path__ + "img/img4.95ce3c17.png";